import { directories, uploadToS3 } from "../../../../../utils/S3";

/** Upload a payment proof file to storage and return its URL. */
export const uploadPayrollProof = async (file, options = {}) => {
  if (!file) return null;

  const ext = String(file.name || "").split(".").pop() || "pdf";
  const fileName = `payment_proof.${ext}`;
  const data = await uploadToS3(file, fileName, directories.payroll, {
    onProgress: options.onProgress,
  });
  return data?.link || null;
};
